import { createAsyncThunk } from '@reduxjs/toolkit';
import { _commonUrls } from '@custom/Utils/constants/apiUrls';

const getRadiologistList = createAsyncThunk('getRadiologistList', async () => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      let url = _commonUrls.getHospitalRadiologists;
      let response = await fetch(`${url}?hospitalId=${hospitalId}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Billing Details');
      }

      const data = await response.json();

      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default getRadiologistList;
